<template>
  <v-navigation-drawer v-model="show" persistent fixed width="600">
    <v-toolbar  color="white" class="elevation-0" >
      <v-icon @click="clear">close</v-icon>
      <v-toolbar-title>Filtros</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn  flat @click="clear">Limpar</v-btn>
        <v-btn  flat @click="apply">Aplicar</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <div>
    <v-subheader>Vencimento em</v-subheader>

    <v-layout row wrap>
    <!--Begin-->
      <v-flex xs12 lg6>
        <v-menu :close-on-content-click="true" :nudge-right="40"
          lazy transition="scale-transition" offset-y full-width
        >
          <v-text-field slot="activator" v-model="dateFormatted[0]"
          label="Data inicial" persistent-hint prepend-icon="event" ></v-text-field>
          <v-date-picker v-model="initialDate" no-title></v-date-picker>
        </v-menu>
      </v-flex>

      <!--END-->
       <v-flex xs12 lg6>
        <v-menu :close-on-content-click="true" :nudge-right="40"
        lazy transition="scale-transition" offset-y full-width >
          <v-text-field slot="activator" v-model="dateFormatted[1]"
          label="Data Final" persistent-hint prepend-icon="event" ></v-text-field>
          <v-date-picker v-model="finalDate" no-title></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>

  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import { EventBus } from '@/services/event-bus';

export default {
  name: 'Invoices',
  computed: {
    dateFormatted() {
      return [
        moment(this.initialDate).format('DD/MM/YYYY'),
        moment(this.finalDate).format('DD/MM/YYYY')];
    },
    initialDate: {
      get() { return this.initial; },
      set(newDate) {
        this.$store.dispatch('invoices/updateInitialDate', newDate);
        this.initial;
      },
    },
    finalDate: {
      get() { return this.final },
      set(newDate) {
        this.$store.dispatch('invoices/updateFinalDate', newDate);
        this.final;
      },
    },
    ...mapGetters({
      visible: 'invoices/filterVisible',
      initial: 'invoices/initialDate',
      final: 'invoices/finalDate',
    }),
  },

  methods: {
    clear() {
      this.$store.dispatch('invoices/resetFilters');
      this.$store.dispatch('invoices/load', this.filters);
      this.$store.dispatch('invoices/hideFilters');
    },
    apply() {
      this.$store.dispatch('invoices/load', this.filters);
      this.$store.dispatch('invoices/hideFilters');
    }
  },
  data() {
    return { show: false }
  },
  watch: {
    visible(value) {
      this.show = value;
    }
  }
};

</script>
